module.exports = __webpack_public_path__ + "static/media/warning.9d0b153f.svg";